import React from 'react';
import { authRoles } from 'app/auth';

export const VerifyPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/verify',
			component: React.lazy(() => import('./Verify'))
		}
	]
};
